import React, { ReactElement } from "react";
import KunduzDesktopLogo from "@icons/kunduzLogo.svg";
import KunduzMobileLogo from "@icons/kunduzMobileIcon.svg";
import Link from "next/link";
import styles from "./logo.module.scss";
import classNames from "classnames";

export const HeaderLogo = (props: Props): ReactElement => {
  const OuterComponent = props.linkPath ? Link : "div";
  return (
    <>
      <OuterComponent
        href={props.linkPath as string}
        className={styles.desktopOuter}
      >
        <KunduzDesktopLogo className={styles.desktopLogo} />
      </OuterComponent>
      <OuterComponent
        className={classNames(styles.mobileOuter, {
          [styles.mini]: props.mini,
        })}
        href={props.linkPath as string}
      >
        <KunduzMobileLogo className={styles.mobileLogo} />
      </OuterComponent>
    </>
  );
};

interface Props {
  mini?: boolean;
  linkPath?: string;
}
